// src/redux/store.ts
import { configureStore } from '@reduxjs/toolkit'
import homeReducer from '../features/home/homeSlice'
import authReducer from '../features/auth/authSlice'

export const store = configureStore({
  reducer: {
    home: homeReducer,
    auth: authReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
